module.exports = __webpack_public_path__ + "static/media/sip_icn.78e60981.svg";